module.exports = __webpack_public_path__ + "static/img/fluent-pause-circle-24-regular.c60b6c24.svg";